module.exports = __webpack_public_path__ + "img/Group 27157.ad56ee9c.svg";